import { PropsWithChildren } from 'react';
import { SidebarDrawerProvider } from './SidebarDrawerContext';

export function Providers({ children }: PropsWithChildren) {
  return <SidebarDrawerProvider>{children}</SidebarDrawerProvider>;
}
